import { useState } from "react";
import { ErrorUtils } from "../utils";

export const useSessionStorage = (key: string | undefined, initValue?: any) => {
  const [storedValue, setStoredValue] = useState(() => {
    if (!key) return undefined;
    try {
      const item = sessionStorage.getItem(key);

      return item ? JSON.parse(item) : initValue;
    } catch (error) {
      console.error(error);

      return initValue;
    }
  });

  const setValue = (value: any) => {
    if (!key) return;
    try {
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;

      setStoredValue(valueToStore);

      sessionStorage.setItem(
        key,
        valueToStore ? JSON.stringify(valueToStore) : "",
      );
    } catch (error) {
      ErrorUtils.showErrorMessage();
    }
  };

  return [storedValue, setValue];
};
